import './../../pages/consult/agreements/AgreementsPage.css';

import { ReactNode } from 'react';
import { Text } from '@bendhealth/common';
import styled from '@emotion/styled';
import { BackArrowButton } from 'components/_global/back-button/BackArrowButton';
import { H3 } from 'components/core/text/Text';
import { useNavigate } from 'react-router-dom';

interface OnboardingTitleProps {
  title: string;
  subTitle?: ReactNode;
  otherChildren?: ReactNode;
  onBackClick?: () => void;
}

const Intro = styled.div`
  display: flex;
  max-width: 800px;
  padding-bottom: 32px;
  @media (--mobile) {
    padding-bottom: 24px;
  }
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;
export default function OnboardingTitle({
  title,
  subTitle,
  otherChildren,
  onBackClick,
}: OnboardingTitleProps) {
  const nav = useNavigate();
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
      return;
    }

    nav(-1);
  };
  return (
    <Intro>
      <BackArrowButton onClick={handleBackClick} />
      <H3>{title}</H3>
      {subTitle && (
        <Text data-testid="formTitle" variant="body-5">
          {subTitle}
        </Text>
      )}
      {otherChildren}
    </Intro>
  );
}
